import Constants from '../constants/Index';
import { ElMessage } from 'element-plus';
import { storageFactory } from "./LocalstorageFactory";

const local = storageFactory(() => localStorage);
//const session = storageFactory(() => sessionStorage);

function formatTime(time: string) {
  return time.substring(0, 16)
}

function successMsg(message: string) {
  ElMessage({
    type: 'success',
    message
  })
}

function warningMsg(message: string) {
  ElMessage({
    type: 'warning',
    message
  })
}

//IE10 以上支持
function Base64Encode(str: string) {
  console.log(str);
  return btoa(encodeURIComponent(str));
}
//IE10 以上支持
function Base64Decode(str: string) {
  return decodeURIComponent(atob(str));
}

function setLocalStore(key: string, value: string) {
  local.setItem(key, Base64Encode(value))
}

function getLocalStore(key: string) {
  const value = local.getItem(key);
  if (value !== null) {
    return Base64Decode(value);
  }
  return "";
}
function clearLocalStore() {
  local.clear();
}

function isLogin() {
  if (getLocalStore(Constants.TokenKey)) {
    return true;
  }
  return false;
}

function getLoginUserId() {
  if (!isLogin) return null;
  const userInfoStr = getLocalStore(Constants.PhoneKey);
  if (userInfoStr) {
    const userInfo = JSON.parse(userInfoStr);
    return userInfo.id;
  }
  return null;
}

function getQiniuVframe(url:string,index = 1) {
  return url + '?vframe/jpg/offset/' + index
}


/**
 * 工具：解析高德IP定位返回值
 * 自动处理 正常字符串 / 空数组[] 两种格式
 * @param amapData 高德接口返回的完整JSON
 * @returns { province, city }
 */
export interface ParseResult {
  province: string
  city: string
}

export function parseAmapIpLocation(amapData: any): ParseResult {
  // 先判断接口是否调用成功
  if (
    !amapData ||
    amapData.status !== '1' ||
    amapData.infocode !== '10000'
  ) {
    return { province: '', city: '' }
  }

  // 安全获取值：处理字符串 / 空数组[]
  const getSafeValue = (value: any): string => {
    // 如果是字符串且不为空 → 返回
    if (typeof value === 'string' && value.trim() !== '') {
      return value.trim()
    }
    // 如果是数组、null、undefined、空字符串 → 返回空
    return ''
  }

  return {
    province: getSafeValue(amapData.province),
    city: getSafeValue(amapData.city),
  }
}


const CommonUtils = {
  formatTime,
  successMsg,
  warningMsg,
  setLocalStore,
  getLocalStore,
  clearLocalStore,
  isLogin,
  getLoginUserId,
  Base64Encode,
  Base64Decode,
  getQiniuVframe,
  parseAmapIpLocation
};


export default CommonUtils;